import { setCardProps, setEditingChapterId } from '../actions';
import { Button, Dropdown, Flex, MenuProps, Tooltip } from 'antd';
import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons';
import UpdateStep from './UpdateStep';
import styles from './Components.module.css';
import React from 'react';
import { Draggable } from 'react-beautiful-dnd';
import { useDispatch } from 'react-redux';

const StepMenuItem = ({
  data,
  step,
  onDeleteStep,
  editingChapterId,
  stepIndex,
  openedStep,
  handleStepChange,
}) => {
  const dispatch = useDispatch();

  const handleMenuItemClick = e => {
    e.domEvent.stopPropagation();

    if (e.key === 'edit') {
      dispatch(setEditingChapterId(step.id));
    }

    if (e.key === 'delete') {
      onDeleteStep(step);
    }
  };

  const handleOpenMenu = e => {
    e.stopPropagation();
    dispatch(setCardProps());
  };

  const handleClickTitle = () => {
    handleStepChange(step);
  };

  const editItems: MenuProps['items'] = [
    {
      key: 'edit',
      icon: <EditOutlined />,
      label: 'Edit Chapter Title',
    },
  ];

  if (!data?.giideLibraryId) {
    editItems.push({
      key: 'delete',
      icon: <DeleteOutlined />,
      danger: true,
      label: 'Delete Chapter',
    });
  }

  return editingChapterId === step.id ? (
    <UpdateStep stepId={step.id} stepTitle={step.title} />
  ) : (
    <Draggable key={step.id} draggableId={step.id} index={stepIndex}>
      {(provided, snapshot) => (
        <div
          className={`${styles.giideMenuItem} ${
            openedStep?.id === step.id ? styles.giideMenuItemSelected : ''
          }`}
          ref={provided.innerRef}
          {...provided.draggableProps}
          {...provided.dragHandleProps}
        >
          {
            <Flex
              justify="space-between"
              align={'center'}
              onClick={handleClickTitle}
            >
              <div className={styles.giideMenuItemTitleCol}>
                {step.title.length > 20 ? (
                  <Tooltip placement="right" title={step.title}>
                    <div className={styles.giideMenuItemTitle}>
                      {stepIndex + 1}. {step.title}
                    </div>
                  </Tooltip>
                ) : (
                  <div className={styles.giideMenuItemTitle}>
                    {stepIndex + 1}. {step.title}
                  </div>
                )}
              </div>
              {!data?.isInGiideStudioLibrary && !step.isInLibrary && (
                <Dropdown
                  trigger={['click']}
                  menu={{
                    items: editItems,
                    onClick: handleMenuItemClick,
                  }}
                >
                  <Button
                    type={'text'}
                    onClick={handleOpenMenu}
                    className={styles.chapterEditButton}
                    icon={<MoreOutlined rotate={90} />}
                  ></Button>
                </Dropdown>
              )}
            </Flex>
          }
        </div>
      )}
    </Draggable>
  );
};

export default StepMenuItem;
